import http from 'axios'

export default {
  getOktaGroups: ({ state, rootState, commit }) => {
    commit('global/setShowLoadingSpinner', true, { root: true })
    return http
      .get('/mrx-gateway/mrxassistmemberservice/admin/api/groups')
      .then(response => {
        commit('setGroupList', response.data)
        commit('global/setShowLoadingSpinner', false, { root: true })
      }).catch(() => {
        commit('global/setShowErrorMessage', true, { root: true })
        commit('global/setShowLoadingSpinner', false, { root: true })
      })
  }
}
